import { isArray } from 'lodash-es';
import type { LocationQueryValue } from 'vue-router';

export const getArray = <T extends LocationQueryValue>(input: T|T[]): T[] => {
    return isArray(input) ? input : [input];
};
